import React from 'react';
import { X } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function ProblemSection() {
  const mistakes = ['Evitar alimentos', 'Remedios caseros', 'Pastillas', 'Consejos de internet'];
  return <section id="problema" className="py-24" data-id="element-320">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-321">
        <SectionHeader tag="El problema real" title={<>
              El fuego no te está
              <br data-id="element-323" />
              quemando solo el pecho.
            </>} subtitle="Te está robando la paz." data-id="element-322" />

        <div className="fade-up bg-surface border border-white/5 rounded-xl p-8 mt-10 mb-16" data-id="element-324">
          <p className="text-lg text-text-muted leading-relaxed mb-6" data-id="element-325">
            No es "solo acidez". Es ese momento miserable en que comes algo
            pequeño… y tu cuerpo responde como si lo hubieras insultado. El
            ardor sube. La garganta arde. La presión aparece. Los gases
            comienzan.
          </p>
          <p className="text-lg text-text-muted leading-relaxed" data-id="element-326">
            Y cuando llega la noche… El ácido sube otra vez. Duermes mal. Te
            despiertas. Te sientas. Esperas que pase. Y lo peor de todo:
            empiezas a vivir con miedo a comer.
          </p>
        </div>

        <h3 className="font-playfair text-3xl md:text-4xl font-black leading-tight text-center" data-id="element-327">
          Ya intentaste:
        </h3>
        <div className="w-16 h-1 bg-gradient-gold mx-auto my-6 rounded-sm" data-id="element-328"></div>

        <ul className="stagger-children list-none mt-10 space-y-4" data-id="element-329">
          {mistakes.map((point, idx) => <li key={idx} className="flex items-start gap-4 p-6 bg-danger/5 border border-danger/10 rounded-xl text-lg text-text-light" data-id="element-330">
              <div className="w-8 h-8 bg-danger/10 rounded-full flex items-center justify-center shrink-0 mt-0.5" data-id="element-331">
                <X className="w-4 h-4 text-danger" data-id="element-332" />
              </div>
              <span className="leading-relaxed" data-id="element-333">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}